export const redirectUserToCheckoutMessage = 'REDIRECT_USER_TO_CHECKOUT';
export const previousConversationPrefix = '**Previous conversation**';
